import React, { Component } from 'react';

class EditData extends Component {
	constructor(props) {
		super(props);
		this.textarea = React.createRef();
	}

	use() {
		this.useData(this.textarea.current.value);
	}

	useData(text) {
		let data;
		try {
			data = [];
			text.split("\n").forEach(row => {
				console.log("row", row, data.length);
				let pos = row.split(",");
				if (pos?.length >= 2)
					data.push([
						parseFloat(pos[0]),
						parseFloat(pos[1]),
						pos[2]?.indexOf("true") >= 0]);
			});
		} catch (e) {
			console.log("Error", e);
			return;
		}
		if (data.length > 0) {
			this.props.setPointsCallback(data, data);
			this.props.setMode("view");
		}
	}

	render() {
		let data;
		if (this.props.points?.length > 0) {
			let arr = [];
			this.props.points.forEach(p => {
				let res = p[0].toString().concat(",").concat(p[1]);
				if (p[2])
					res = res.concat(",true");
				arr.push(res);
			})
			data = arr.join("\n");
		}
		return (
			<div>
				{
					this.state?.error ?
						<div style={{ border: "1px solid black", backgroundColor: "red" }}>
							{this.state.error}
						</div>
						:
						<></>
				}
				<h2>Enter own data</h2>
				You can enter data as comma separated points (one point at each line).
				An extra <i>true</i> can be added as third parameter to indicate end of a continued line (i.e. skip drawing until next point).
				<br />
				<textarea
					cols="60"
					rows="30"
					ref={this.textarea}
					placeholder="x1, y1&#13;&#10;x2, y2&#13;&#10;x3, y3&#13;&#10;..etc&#13;&#10;"
					defaultValue={data}
				/>
				<br />
				<button onClick={() => this.use()}>Use entered data</button>
			</div>
		);
	}
}

export default EditData;